












import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListMenuAddress',
  components: {
    CtrlSearchCommonComponents,
  },
  data: () => ({
    headers: [
      {
        text: 'ページID',
        sortable: true,
        value: 'pageId',
        width: 75,
      },
      {
        text: 'ページ名',
        sortable: true,
        value: 'pageMei',
        width: 340,
      },
      {
        text: '区分',
        sortable: true,
        value: 'kainaiKaigaiKb',
        width: 60,
      },
    ],
    formatColName: 'pageId',
  }),
});
